import { render, staticRenderFns } from "./ProgramSelectboxMultiple.vue?vue&type=template&id=aaf0c382"
import script from "./ProgramSelectboxMultiple.vue?vue&type=script&lang=js"
export * from "./ProgramSelectboxMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports